module.exports = __webpack_public_path__ + "img/leeb-balkone-mitarbeiter-15.bbd7f33e.jpg";